import { useEffect, useRef, useState } from "react";

export default function AboutSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      id="about"
      aria-labelledby="about-heading"
      className="relative py-24 md:py-32 lg:py-40 bg-warm-50 overflow-hidden"
    >
      {/* Decorative line */}
      <div className="absolute top-16 md:top-24 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
        <div className="w-px h-12 md:h-16 bg-warm-400/50" />
        <span className="text-warm-600 text-xs tracking-[0.3em]">宝栄丸</span>
        <div className="w-px h-12 md:h-16 bg-warm-400/50" />
      </div>

      <div className="max-w-3xl mx-auto px-6 md:px-12 pt-24 md:pt-32">
        <div
          className={`text-center transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h2
            id="about-heading"
            className="text-warm-700 text-xs md:text-sm tracking-[0.3em] mb-6 md:mb-8 font-normal"
          >
            伊豆稲取の小さな温泉宿
          </h2>
          <p className="font-serif text-stone-800 text-lg md:text-xl lg:text-2xl leading-[1.8] md:leading-[2]">
            全3室だけの静かな空間で、<br className="hidden md:block" />稲取の海を望みながら天然温泉に浸かる。
            <br className="hidden md:block" />
            日常の喧騒を忘れ、心身ともに解き放つ<br className="hidden md:block" />ひとときをお過ごしください。
          </p>
          <address className="mt-8 text-stone-500 text-sm md:text-base leading-relaxed not-italic">
            静岡県東伊豆町稲取965
            <br />
            伊豆稲取駅より徒歩15分
          </address>
        </div>
      </div>
    </section>
  );
}